export const EMPRESA_LOAD_ALL = "EMPRESA_LOAD_ALL";
export const EMPRESA_CREATE_PRICE_GROUP = "EMPRESA_CREATE_PRICE_GROUP";
export const EMPRESA_CREATE_REMOTE_REPOSITORY =
  "EMPRESA_CREATE_REMOTE_REPOSITORY";
export const EMPRESA_NORMALIZE_IDERP = "EMPRESA_NORMALIZE_IDERP";
export const EMPRESA_COPY_PRICE = "EMPRESA_COPY_PRICE";
export const EMPRESA_SYNCHRONIZE_PRODUCTS = "EMPRESA_SYNCHRONIZE_PRODUCTS";
export const EMPRESA_SYNCHRONIZE_ORDERS = "EMPRESA_SYNCHRONIZE_ORDERS";
export const EMPRESA_SYNCHRONIZE_CLIENTS = "EMPRESA_SYNCHRONIZE_CLIENTS";
export const EMPRESA_CREATE = "EMPRESA_CREATE";
export const EMPRESA_DELETE = "EMPRESA_DELETE";
export const EMPRESA_TFA = "EMPRESA_TFA";
export const EMPRESA_LOAD_TAGS = "EMPRESA_LOAD_TAGS";
export const ERPS = [
  { text: "Winthor", value: "WINTHOR" },
  { text: "Consinco", value: "CONSINCO" },
  { text: "Sidicom", value: "SIDICOM" },
  { text: "Sankhya", value: "SANKHYA" },
  { text: "SAP", value: "SAP" },
  { text: "Proton", value: "PROTON" },
  { text: "VHSYS", value: "VHSYS" },
  { text: "Flex", value: "FLEX" },
  { text: "Sismic", value: "SISMIC" },
  { text: "Artsoft", value: "ARTSOFT" },
  { text: "Microsys", value: "MICROSYS" },
  { text: "Performance", value: "PERFORMANCE" }
];
